import Icon from './icon.vue'
export default Icon



// WEBPACK FOOTER //
// ./src/components/icon/index.js